import { t } from '@lingui/core/macro';
import { validateSocialNetworkUrl, validateUrl } from 'shared/utils';
import * as Yup from 'yup';

// Сообщения — функциями: схема собирается один раз при импорте, а текст нужен на языке момента валидации.
export default Yup.object().shape({
  website: Yup.string().test(
    'is-valid-url',
    () => t`Некорректный URL`,
    function (value) {
      if (!value) {
        return true;
      } // Allow empty value
      const result = validateUrl(value);
      return result.isValid ? true : this.createError({ message: result.errorMessage || t`Некорректный URL` });
    },
  ),
  vk: Yup.string().test(
    'is-valid-vk',
    () => t`Некорректная ссылка ВКонтакте`,
    function (value) {
      if (!value) {
        return true;
      } // Allow empty value
      const urlResult = validateUrl(value);
      if (!urlResult.isValid) {
        return this.createError({
          message: urlResult.errorMessage || t`Некорректная ссылка ВКонтакте`,
        });
      }

      const socialResult = validateSocialNetworkUrl(value, 'vk');
      return socialResult.isValid
        ? true
        : this.createError({
            message: socialResult.errorMessage || t`Некорректная ссылка ВКонтакте`,
          });
    },
  ),
  'vk-video': Yup.string().test(
    'is-valid-vk-video',
    () => t`Некорректная ссылка ВКвидео`,
    function (value) {
      if (!value) {
        return true;
      } // Allow empty value
      const urlResult = validateUrl(value);
      if (!urlResult.isValid) {
        return this.createError({
          message: urlResult.errorMessage || t`Некорректная ссылка ВКвидео`,
        });
      }

      const socialResult = validateSocialNetworkUrl(value, 'vk-video');
      return socialResult.isValid
        ? true
        : this.createError({
            message: socialResult.errorMessage || t`Некорректная ссылка ВКвидео`,
          });
    },
  ),
  telegram: Yup.string().test(
    'is-valid-telegram',
    () => t`Некорректная ссылка Telegram`,
    function (value) {
      if (!value) {
        return true;
      } // Allow empty value
      const urlResult = validateUrl(value);
      if (!urlResult.isValid) {
        return this.createError({
          message: urlResult.errorMessage || t`Некорректная ссылка Telegram`,
        });
      }

      const socialResult = validateSocialNetworkUrl(value, 'telegram');
      return socialResult.isValid
        ? true
        : this.createError({
            message: socialResult.errorMessage || t`Некорректная ссылка Telegram`,
          });
    },
  ),
  youtube: Yup.string().test(
    'is-valid-youtube',
    () => t`Некорректная ссылка YouTube`,
    function (value) {
      if (!value) {
        return true;
      } // Allow empty value
      const urlResult = validateUrl(value);
      if (!urlResult.isValid) {
        return this.createError({
          message: urlResult.errorMessage || t`Некорректная ссылка YouTube`,
        });
      }

      const socialResult = validateSocialNetworkUrl(value, 'youtube');
      return socialResult.isValid ? true : this.createError({ message: socialResult.errorMessage || t`Некорректная ссылка YouTube` });
    },
  ),
  instagram: Yup.string().test(
    'is-valid-instagram',
    () => t`Некорректная ссылка Instagram`,
    function (value) {
      if (!value) {
        return true;
      } // Allow empty value
      const urlResult = validateUrl(value);
      if (!urlResult.isValid) {
        return this.createError({
          message: urlResult.errorMessage || t`Некорректная ссылка Instagram`,
        });
      }

      const socialResult = validateSocialNetworkUrl(value, 'instagram');
      return socialResult.isValid
        ? true
        : this.createError({
            message: socialResult.errorMessage || t`Некорректная ссылка Instagram`,
          });
    },
  ),
});
